import type { AiLabelType } from '@/types/Recipes';
import { createContext, useContext } from 'react';

export interface AiDisclosureContent {
  text?: string;
  title?: string;
  type?: AiLabelType;
}

export interface AiDisclosureContextValue extends AiDisclosureContent {
  isOpen: boolean;
  activeTrigger: HTMLElement | null;
  open: (content: AiDisclosureContent, trigger: HTMLElement) => void;
  close: () => void;
  showBadge: boolean;
}

export const AiDisclosureContext = createContext<AiDisclosureContextValue>({
  isOpen: false,
  text: undefined,
  title: undefined,
  activeTrigger: null,
  open: () => {},
  close: () => {},
  showBadge: false,
});

export const useAiDisclosure = () => useContext(AiDisclosureContext);
